import React, { useState } from 'react';
import './PasswordLogin.css';

interface PasswordLoginProps {
  onLogin: (password: string) => void;
}

const PasswordLogin: React.FC<PasswordLoginProps> = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'applab') {
      setError('');
      onLogin(password);
    } else {
      setError('Falsches Passwort');
      setPassword('');
    }
  };

  return (
    <div className="password-login">
      <div className="login-container">
        <div className="login-header">
          <h1>Energy Forecast</h1>
          <p>Strompreise DE-LU</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label htmlFor="password">Passwort</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Passwort eingeben"
              autoFocus
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-button">
            Anmelden
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordLogin;